import { language } from './language';

export const validateIdentifier = () => ({
  pattern: /^\d{12}$/,
  message: language.identity_card_must_be_12_digits,
});

export const validateBudgetRelationshipCode = () => ({
  pattern: /^\d{7}$/,
  message: language.the_budgetary_relationship_code_must_contain_exactly_7_characters,
});

export const validateEInvoiceTaxCodeLength = () => ({
  validator(_, value) {
    if (!value) return Promise.resolve();
    const cleanedValue = value.replace(/-/, '').trim();
    if (cleanedValue.length < 9 || cleanedValue.length > 13) {
      return Promise.reject(language.tax_code_mixed_invalid);
    }
    return Promise.resolve();
  },
});

export const validateTaxCode = () => ({ getFieldValue }) => ({
  validator(_, value) {
    if (!value) return Promise.resolve();

    const cleanedValue = value.replace(/-/, '').trim();
    const hasFullName = !!getFieldValue('eInvoiceFullName');
    const hasCompanyName = !!getFieldValue('eInvoiceCompanyName');

    if (hasFullName && hasCompanyName && value.length !== 10 && cleanedValue.length !== 13) {
      return Promise.reject(language.tax_code_mixed_invalid);
    }
    if (hasFullName && !hasCompanyName && value.length !== 10) {
      return Promise.reject(language.tax_code_individual_invalid);
    }
    if (hasCompanyName && !hasFullName && value?.includes('-') && cleanedValue.length !== 13) {
      return Promise.reject(language.tax_code_organization_invalid);
    }

    return Promise.resolve();
  },
});

export const validateAddressWhenTaxCodeProvided = () => ({ getFieldValue }) => ({
  validator(_, value) {
    if ((value === '' || value === undefined || value === null) && getFieldValue('eInvoiceTaxCode')) {
      return Promise.reject(language.address_required_when_tax_code_provided);
    }
    return Promise.resolve();
  },
});
